import {
  LanguageFactory,
} from 'webcommon/legacy-common';

export function LanguageFactoryFactory(i: angular.auto.IInjectorService) {
  return i.get<LanguageFactory>('LanguageFactoryJs');
}

export const LanguageFactoryAjsProvider = {
  deps: ['$injector'],
  provide: LanguageFactory,
  useFactory: LanguageFactoryFactory,
};
